/**
 * 版位在上游（AsiaMax）的狀態。
 *
 * 與 `SpaceHealthState` 不是同一件事：這裡是版位本身被設成什麼狀態，
 * 那裡是投遞健康度（訊號異常、服務啟用中…）。兩者都會出現在版位相關的端點上，
 * 名字接近但值域不同，別互相代入。
 */
export enum SpaceStatus {
  ON = 'ON',
  OFF = 'OFF',
  TESTING = 'TESTING',
  BANNED = 'BANNED',
  SUSPENDED = 'SUSPENDED'
}

/**
 * 全部五種狀態。
 *
 * 版位屬性的端點不帶狀態條件時只涵蓋 `ON`，那是廣告活動選版位要的範圍；
 * 要列出「這個渠道底下所有版位」的畫面得把五種都帶上，否則非 ON 的版位
 * 在清單裡看得到、在篩選選項裡卻找不到。
 */
export const ALL_SPACE_STATUSES: SpaceStatus[] = Object.values(SpaceStatus);
